import { ComponentPropsWithRef, forwardRef } from "react";
import clsx from "clsx";
import "./LoadingIndicator.css";
import Loader from "./Loader";

const LoadingIndicator = forwardRef(function LoadingIndicator(
    props: LoadingIndicatorProps,
    ref: any
) {
    const { className, ...restProps } = props;

    return (
        <div ref={ref} className={clsx("LoadingIndicator", className)} {...restProps}>
            <Loader />
        </div>
    );
});

export default LoadingIndicator;

export type LoadingIndicatorProps = {} & ComponentPropsWithRef<"div">;
